const EService = {
  List: "/Tables/EService/List",
  Info: "/Tables/EService/Info",
  Export: "/Tables/EService/Export",
};

export default {
  EService,
};
